import { useState } from 'react'
import { starterFish } from '../data/catalog'
import { useAppStore } from '../store'
import { Aquarium, FishVector } from './Aquarium'

export function Onboarding({ onReady }: { onReady: () => void }) {
  const { chooseStarter } = useAppStore()
  const [step, setStep] = useState<'welcome' | 'fish'>('welcome')

  if (step === 'welcome') {
    return (
      <main className="onboarding">
        <Aquarium compact />
        <section className="onboarding-card">
          <div className="brand-mark" aria-hidden="true">TC</div>
          <p className="eyebrow">A calmer way to get things done</p>
          <h1>ThriveCove</h1>
          <p className="promise">Grow your focus, one calm session at a time.</p>
          <p>Complete honest focus sessions. Feed your fish. Watch a living cove become the story of your effort.</p>
          <button className="primary large" onClick={() => setStep('fish')}>Start focusing</button>
          <button className="text-button" onClick={() => setStep('fish')}>Continue locally — no account required</button>
        </section>
      </main>
    )
  }

  return (
    <main className="starter-screen">
      <section className="starter-copy">
        <p className="eyebrow">Your first companion</p>
        <h1>Choose a starter fish</h1>
        <p>All three have equal value. Pick the one that makes your cove feel like home.</p>
      </section>
      <div className="starter-grid">
        {starterFish.map((fish) => (
          <button
            className="starter-card"
            key={fish.id}
            onClick={() => {
              chooseStarter(fish.id)
              onReady()
            }}
          >
            <div className="starter-preview"><FishVector item={fish} stage={1} /></div>
            <strong>{fish.name}</strong>
            <span>{fish.shape === 'slim' ? 'Quiet and bright' : fish.shape === 'round' ? 'Warm and friendly' : 'Curious and flowing'}</span>
          </button>
        ))}
      </div>
      <p className="muted centered">You can discover the others later through focus.</p>
    </main>
  )
}
